import { z } from 'zod'

/**
 * Représentation d'un email d'utilisateur
 */
export const UserEmailSchema = z .string().trim().toLowerCase().email("L'email est invalide")
  .refine((value) => {
    const parts = value.split('@')
    return parts.length === 2 && parts[0].length > 0 && parts[0].length < 64 && parts[1].length > 0 && parts[1].length < 255
  }, "Le format du mail est invalide <longueur 63>@<longueur 254>")
export type UserEmailEntity = z.infer<typeof UserEmailSchema>